var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLadder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/hazard/ladder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/hazard/ladder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7777302,65.8243905 C37.432327,65.8243905 37.103424,65.8837911 36.7844211,65.9673918 L37.6347288,52.1347651 L62.3662554,52.1347651 L63.2077631,65.8243905 L37.7777302,65.8243905 Z M61.0407433,30.624068 L61.884451,44.3125934 L38.1165333,44.3125934 L38.959141,30.624068 L61.0407433,30.624068 Z M68.0819078,17.6725494 C67.9499066,15.5165296 66.0985896,13.8588144 63.9370698,14.0095158 C61.7821501,14.141517 60.1420351,15.997234 60.2740363,18.1532538 L60.5600389,22.8018964 L39.4409454,22.8018964 L39.725848,18.1532538 C39.8589492,15.997234 38.2177342,14.141517 36.0628144,14.0095158 C33.9045947,13.8588144 32.0510777,15.5165296 31.9190765,17.6725494 L28.0074406,81.2278317 C27.8754394,83.3838514 29.5155545,85.2384684 31.6704742,85.3726696 C31.751875,85.3770697 31.8343757,85.3792697 31.9146764,85.3792697 C33.9650952,85.3792697 35.687711,83.7831551 35.8153122,81.7085361 L36.3290169,73.3616596 C36.777821,73.5409612 37.2640255,73.6454622 37.7777302,73.6454622 L63.6895676,73.6454622 L64.1856721,81.7085361 C64.3132733,83.7831551 66.034789,85.3792697 68.0863078,85.3792697 C68.1666086,85.3792697 68.2480093,85.3770697 68.3294101,85.3726696 C70.4843298,85.2384684 72.1255448,83.3838514 71.9924436,81.2278317 L68.0819078,17.6725494 Z",
    id: "ladder",
    fill: "#1C7B97"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLadder);
export default __webpack_public_path__ + "static/media/ladder.080a0abd.svg";
export { ForwardRef as ReactComponent };